<template>
  <div>
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1 table-week"
        :options.sync="options"
        @update:options="updateOptions"
        :server-items-length="totalRecords"
        :loading="loading"
        hide-default-footer
        :height="windowHeight"
        fixed-header
        ref="right_table"
    >
      <template v-slot:top>
        <v-toolbar dense class="mt-2 mb-2" elevation="1" color="gridtoolbar">
          <BaseCircleIndicator
              title="SMD debt %"
              :value="commonRecords.smd_debt"
              :value_green="10"
              :value_red="20"
          >
          </BaseCircleIndicator>
          <BaseCircleIndicator
              title="THT debt %"
              :value="commonRecords.tht_debt"
              :value_green="10"
              :value_red="20"
          >
          </BaseCircleIndicator>
          <v-divider></v-divider>
          <v-btn
            dark
            small
            fab
            color="primary"
            @click="onAutoDelivery"
            :loading="action_unrefreshed"
            :disable="action_unrefreshed"
          >
            <v-icon dark>
              mdi-auto-fix
            </v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.wd1="{ item }">
        <BatchRunCard week_day="1" :item=item />
      </template>
      <template v-slot:item.wd2="{ item }">
        <BatchRunCard week_day="2" :item=item />
      </template>
      <template v-slot:item.wd3="{ item }">
        <BatchRunCard week_day="3" :item=item />
      </template>
      <template v-slot:item.wd4="{ item }">
        <BatchRunCard week_day="4" :item=item />
      </template>
      <template v-slot:item.wd5="{ item }">
        <BatchRunCard week_day="5" :item=item />
      </template>
      <template v-slot:item.indicator="{ item }">
        <v-container fluid>
          <v-row>
            <v-col>
              <BatchRunIndicator :item=item />
            </v-col>
            <v-col class="mt-12">
              <BatchRunListDialog :subheight="300" :year_week_id="item.id"/>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:footer>
        <v-card class="px-3 py-1">
          <span v-if="active_batch_run != null">
            <b>{{ active_batch_run.index }}. </b>
            <b>Title:</b> {{ active_batch_run.title }}
            <span v-if="active_batch_run.smd_start_plan != null">
              <b>SMD plan:</b> {{
                active_batch_run.smd_start_plan | moment("DD.MM.YYYY")
              }} - {{ active_batch_run.smd_end_plan | moment("DD.MM.YYYY") }}
            </span>
            <span v-if="active_batch_run.tht_start_plan != null">
              <b>THT plan:</b> {{
                active_batch_run.tht_start_plan | moment("DD.MM.YYYY")
              }} - {{ active_batch_run.tht_end_plan | moment("DD.MM.YYYY") }}
            </span>
          </span>
        </v-card>
      </template>
    </v-data-table>
    <BatchRunConfirmationDialog></BatchRunConfirmationDialog>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import Sortable from 'sortablejs';
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import BaseTaskProgress from "@/components/BaseTaskProgress"
import BaseCircleIndicator from "@/components/Base/BaseCircleIndicator";
import BatchRunCard from "@/components/BatchRun/BatchRunCard";
import BatchRunIndicator from "@/components/BatchRun/BatchRunIndicator";
import BatchRunListDialog from "@/components/BatchRun/BatchRunListDialog";
import BatchRunConfirmationDialog from "@/components/BatchRun/BatchRunConfirmationDialog"

export default {
  name: 'BatchRunWeekList',
  props: {
    'subheight': {type: [Number], default: 120},
  },

  components: {
    BaseCircleIndicator,
    BatchRunCard,
    BatchRunIndicator,
    BatchRunListDialog,
    BatchRunConfirmationDialog,
  },

  computed: {
    ...mapGetters('BatchRunWeek', ['getColumns']),
    ...mapFields('BatchRunWeek', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive',
      'active_batch_run', 'commonRecords', 'action_unrefreshed']),
  },

  methods: {
    ...mapActions('BatchRunWeek', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchActionItem']),

    onResize() {
      this.windowHeight = (window.innerHeight - this.subheight) + 'px'
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm')
      this.options.page = 1
      this.fetchItemList()
    }, 800),

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList()
    },

    onNotion(item) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
    onSyncNotion() {
      // console.log('onSyncNotion')
      this.fetchSyncNotionSelectedItems();
    },
    onRestore() {
      // console.log('onRestore')
      this.fetchRestoreSelectedItems();
    },
    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },
    onAutoDelivery() {
      let action = {
        action_name: 'set_batch_run_auto_delivery_date',
        // id_list: null,
        // parameters: null,
      }
      this.fetchActionItem(action)
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      windowHeight: (window.innerHeight - this.subheight) + 'px',
    }
  }
}
</script>

<style scoped lang="scss">
.table-week {
  background-color: #EEEEEE !important;
}
</style>
